/**
 * TT registr skladů (Materiály › Sklady) — `warehouse_profile`.
 * Bez stromu kategorií: sklady se třídí jen osobní vs neosobní
 * (`users.warehouse_id` / `linkedUserId`, viz warehouse-ui-group.util).
 */

/** Metadata skladu v TT (`warehouse_profile`); zásoby v `warehouse_stock_item`. */
export type WarehouseValuationMethod = 'LIFO';

export const WAREHOUSE_VALUATION_METHOD: WarehouseValuationMethod = 'LIFO';

export interface WarehouseProfileDto {
  warehouseId: string;
  name: string;
  address: string | null;
  responsibleCompanyName: string | null;
  responsibleCompanyIco: string | null;
  responsibleCompanyAddress: string | null;
  /** Vždy LIFO — bez přepínače. */
  valuationMethod: WarehouseValuationMethod;
  updatedAt: string | null;
  updatedBy: string | null;
  /** Warehouse.type (Simple / Positional). */
  type?: string | null;
  /** Propojený TelcoTrack uživatel (`users.warehouse_id`) → osobní sklad. */
  linkedUserId?: string | null;
  /**
   * Role propojeného uživatele (osobní sklad).
   * Prázdné / null u neosobních — filtr Rolí je pak neaplikuje.
   */
  linkedUserRoles?: string[] | null;
  /**
   * Vyřešená firma tenantu: osobní = firma uživatele;
   * neosobní = shoda `responsibleCompany*` s `tenant_companies`.
   */
  companyId?: string | null;
  /** Zobrazovaný název firmy (katalog nebo `responsibleCompanyName`). */
  companyName?: string | null;
  /** Pobočka propojeného uživatele (jen osobní sklady). */
  branch?: string | null;
}

export interface WarehouseProfileUpdateInput {
  address?: string | null;
  responsibleCompanyName?: string | null;
  responsibleCompanyIco?: string | null;
  responsibleCompanyAddress?: string | null;
  /** Přejmenování skladu. */
  name?: string;
}

export interface WarehouseRegistryCreateInput {
  name: string;
  address?: string | null;
  responsibleCompanyName?: string | null;
  responsibleCompanyIco?: string | null;
  responsibleCompanyAddress?: string | null;
}
